module.exports = __webpack_public_path__ + "static/bg.92a91ff9.png";